export default __webpack_public_path__ + "static/media/Atlantech Process Technology.da44379b.png";